import SvgIcon from "./IconArrowUpRight.svg?react";

export const IconArrowUpRight = SvgIcon;
